module.exports = __webpack_public_path__ + "img/document.b125d05b.svg";